var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"orange-button"},_vm.$listeners),[_vm._t("default"),(_vm.isLoading)?_c('SpinnerLoader',{staticClass:"ml-2"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }